import HallManagerContainer from "../../container/admin/hall-manager";

const HallManager = () => {
    return <HallManagerContainer />;
};

export default HallManager;